import { readPathValue } from "./string";

export function isNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function isPositiveFinite(value: unknown): value is number {
  return isNumber(value) && Number.isFinite(value) && value >= 0;
}

export function safeReadNumber(obj: unknown, path: string): number | undefined {
  const value = readPathValue(obj, path);
  return isNumber(value) ? value : undefined;
}
